interface EventErrorStateProps {
  error: string | null
}

export const EventErrorState = ({ error }: EventErrorStateProps) => {
  return (
    <div className="w-full max-w-[1304px] mx-auto sm:px-2 px-4 pt-[50px] pb-10">
      <div className="flex items-center justify-center py-20">
        <p className="text-base text-[#242F3E]">{error || "Event not found"}</p>
      </div>
    </div>
  )
}

